/**
 * SchemaHasInstructionsGate
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectSchemaValue } from '../../services/schemas/selectors';

interface Props {
    children: React.Node;
    hasInstructions?: ?boolean;
}

export class SchemaHasInstructionsGate extends React.PureComponent<Props> {
    render() {
        const { children, hasInstructions } = this.props;
        if (!hasInstructions) return null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector({
    hasInstructions: makeSelectSchemaValue('hasInstructions')
});

export default connect(mapStateToProps)(SchemaHasInstructionsGate);
